export default function (target) {
    this.$vuetify.goTo(target)

    if (this.drawer) {
        this.drawer = false
    }
}
